"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _utils = require("../../../utils");

var _getKeyAssetIdFromVideos = _interopRequireDefault(require("../../../utils/getKeyAssetIdFromVideos"));

require("../styles/_video-project-card.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function VideoProjectCard(_ref) {
  var gotoProject = _ref.gotoProject,
      videoProjectId = _ref.videoProjectId,
      videoFolderId = _ref.videoFolderId,
      name = _ref.name,
      videoCount = _ref.videoCount,
      connectDragSource = _ref.connectDragSource,
      folders = _ref.folders,
      videos = _ref.videos;
  var folderForCard = videoFolderId && folders ? folders.find(function (folder) {
    return folder.videoFolderId === videoFolderId;
  }) : '';
  var keyAssetId = (0, _getKeyAssetIdFromVideos.default)(videos);
  var onClick = gotoProject(videoProjectId);
  return connectDragSource( /*#__PURE__*/_react.default.createElement("div", {
    className: "project-list-item",
    onClick: onClick,
    tabIndex: 0,
    onKeyDown: onClick,
    role: "button"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project-list-item__preview"
  }, !keyAssetId ? /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
    defaultImageIcon: "projects",
    defaultIconColour: "michael",
    defaultIconSize: 75,
    height: "180px",
    width: "295px"
  }) : /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
    assetId: keyAssetId,
    height: "180px",
    width: "295px",
    borderRadius: 6,
    hideFileTypeIcon: true,
    canPlayVideo: false,
    darkMode: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "project-list-item__body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project-list-item__body__name"
  }, name), folderForCard ? /*#__PURE__*/_react.default.createElement("div", {
    className: "project-list-item__folder"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "folder",
    color: "michael",
    size: 15
  }), /*#__PURE__*/_react.default.createElement("p", null, folderForCard.name)) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "project-list-item__body__stats"
  }, (0, _utils.videoCountString)(videoCount)))));
}

var _default = VideoProjectCard;
exports.default = _default;